import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';

@Component({
    selector     : '.deleteDialog',
    templateUrl  : './delete-confirmation-dialog.component.html',
    styleUrls    : ['./delete-confirmation-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DeleteConfirmationDialogComponent implements OnInit
{
    title = '';
    message = '';
    isChecked = false;
    deleteOn = true;

    constructor(public matDialogRef: MatDialogRef<DeleteConfirmationDialogComponent>,
                @Inject(MAT_DIALOG_DATA) private _data: any,
                private _matDialog: MatDialog,
                private _formBuilder: FormBuilder,
    )
    {
    }

    ngOnInit(): void
    {
        this.title = this._data.title;
        this.message = this._data.message;
    }

    onChange(e): void
    {
        this.deleteOn = !this.deleteOn;
    }

}
